<template>
  <div>
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col cols="4">
          <v-select outlined
            :label="$t('application.documents.school-region')"
            v-model="schoolRegion"
            :items="schoolRegions"
            @change="onRegionChanged"
            :disabled="computedAnotherSchool"
          />
        </v-col>
        <v-col cols="4">
          <v-select outlined
            :label="$t('application.documents.school-municipality')"
            v-model="schoolMunicipality"
            :items="schoolMunicipalities"
            @change="onMunicipalityChanged"
            :disabled="computedAnotherSchool"
          />
        </v-col>
        <v-col cols="4">
          <v-select outlined
            :label="$t('application.documents.school-name')"
            v-model="schoolId"
            :items="schools"
            item-text="name"
            item-value="id"
            :disabled="computedAnotherSchool"
            :rules="this.computedAnotherSchool ? undefined : [rules.required]"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox class="mt-0 marked-blue label-top" 
            v-model="computedAnotherSchool" 
            :label="$t('application.documents.another-school')"
            @change="onAnotherSchoolChanged"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import API from '@/services/api';
import uniq from "lodash/uniq";
import { RulesMixin } from '@/components/mixins';

export default {
  name: 'ApplicationDocumentSchool',

  mixins: [RulesMixin],

  props: {
    value: { type: Number, required: false, default: null },
    anotherSchool: { type: Boolean, default: false },
  },

  data: () => ({
    schoolRegion: null,
    schoolMunicipality: null,
    allSchools: [],
    schoolRegions: [],
    schoolMunicipalities: [],
    schools: [],
  }),

  computed:{
    computedAnotherSchool:{
      get(){
        return this.anotherSchool
      },
      set(v){
        this.$emit('update:anotherSchool', v)
      }
    },
    schoolId:{
      get(){
        return this.value;
      },
      set(v){
        this.$emit('input', v)
      }
    }
  },

  created(){
    this.fetchSchool();
  },

  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    onAnotherSchoolChanged(v){
      if(!v){
        return 
      }
      this.schoolRegion = null;
      this.onRegionChanged()
    },

    onRegionChanged(region = null, shcool){
      this.schoolMunicipality = null;
      this.schoolId = null;

      this.schoolMunicipalities = [];
      this.schools = [];

      if(!region){
        return;
      }

      const schoolMunicipalities = this.allSchools.reduce((acc, curr) => {
        if(curr.region !== region){
          return acc;
        }
        return [...acc, curr.municipality]
      }, [])

      this.schoolMunicipalities = uniq(schoolMunicipalities)
      if(shcool){
        this.schoolRegion = region;
        this.onMunicipalityChanged(shcool.municipality, shcool)
      } else if(this.schoolMunicipalities.length === 1){
        this.onMunicipalityChanged(this.schoolMunicipalities[0])
      }
    },

    onMunicipalityChanged(municipality, shcool){
      this.schoolId = null;

      if(!municipality){
        return;
      }

      const schools = this.allSchools.reduce((acc, curr) => {
        if(curr.region !== this.schoolRegion || curr.municipality !== municipality){
          return acc
        }
        return [...acc, { id: curr.id, name: curr.name }]
      }, [])

      this.schools = uniq(schools, s => s.id)
      if(shcool){
        this.schoolMunicipality = municipality;
        this.schoolId = shcool.id;
      }else if(this.schools.length === 1) {
        this.schoolId = this.schools[0].id
      }
    },

    fetchSchool(){
       API.listSchool().then((res) => {
        this.allSchools = res.data;
        this.schoolRegions = uniq(this.allSchools.map(s => s.region))
        const shcool = this.allSchools.find(s => s.id === this.value)
        this.fillData(shcool)
       }).catch(() => {
        this.allSchools = []
       })
    },

    fillData(shcool){
      if(!this.value || !shcool){
        return;
      }
      this.onRegionChanged(shcool.region, shcool)
    }
  }
}
</script>